import Delivery from "../components/delivery/Delivery";
import Layout from "../layout/Layout";

const DeliveryPage = () => {
  return (
    <Layout>
      <Delivery />
    </Layout>
  );
};

export default DeliveryPage;
